import { render, staticRenderFns } from "./main.vue?vue&type=template&id=6148bc17&scoped=true&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=6148bc17&lang=sass&scoped=true&"
import style1 from "./main.vue?vue&type=style&index=1&id=6148bc17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6148bc17",
  null
  
)

/* custom blocks */
import block0 from "./main.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports